<div class="onboarding-panel-card">
  <div *ngIf="data?.header?.value" class="onboarding-panel-card__header">
    {{ data.header.value }}
  </div>
  <div *ngIf="data?.price?.value" class="onboarding-panel-card__price">
    <div class="onboarding-panel-card__price-value">
      <strong>{{ data.price.value }}</strong>
      <div *ngIf="isCurrencyNumber" class="onboarding-panel-card__price-currency">
        {{ "licensePanel.Item.Price.Currency" | translate }}
      </div>
    </div>
    <div
      *ngIf="data?.priceDescription?.value"
      class="onboarding-panel-card__price-description"
    >
      {{ data.priceDescription.value }}
    </div>
  </div>
  <div
    *ngIf="data?.info?.value"
    class="onboarding-panel-card__info"
    [innerHTML]="data.info.value | safe"
  ></div>
  <div class="onboarding-panel-card__action">
    <a
      *ngIf="data?.link?.value"
      [href]="data.link.value.url"
      [target]="data.link.value.target || '_self'"
      class="onboarding-panel-card__link"
      >{{ data.link.value.name }}</a
    >
  </div>
</div>
